// import api from '../services/api';
// import { ApiError, refreshAccessToken } from '../services/apiClient';
// import tokenStore from '../services/tokenStore';
// import { API } from '../config/apiEndpoints';
// import appConfig from '../config/appConfig';
// import { SELF_SIGNUP_ROLES } from '../config/roles';
// import { toSessionUser } from './sessionUser';

// // Real backend. Expected contract:
// //   POST /auth/login    { email, password }        → { accessToken, expiresIn, user }  + sets httpOnly refresh cookie
// //   POST /auth/refresh  (refresh cookie)           → { accessToken, expiresIn, user? }
// //   GET  /auth/me       (Bearer access token)      → user
// //   POST /auth/logout   (refresh cookie)           → revokes the refresh token and clears the cookie
// const realAuthService = {
//   async login({ email, password, remember = false }) {
//     // `remember` asks the server for a longer-lived refresh cookie; the access token stays in memory either way.
//     const data = await api.post(API.auth.login, { email: email.trim().toLowerCase(), password, remember: Boolean(remember) }, { skipAuthRefresh: true });
//     tokenStore.set(data.accessToken, data.expiresIn);
//     return toSessionUser(data.user);
//   },

//   async register({ role, name, email, phone, password }) {
//     if (!SELF_SIGNUP_ROLES.includes(role)) throw new ApiError({ message: 'Choose sender or traveller.', status: 400, code: 'INVALID_ROLE' });
//     return api.post(API.auth.register, { role, name: name.trim(), email: email.trim().toLowerCase(), phone: phone.trim(), password }, { skipAuthRefresh: true });
//   },

//   // On page load: use the refresh cookie to get a fresh access token, then load the user.
//   async restore() {
//     const data = await refreshAccessToken();
//     return toSessionUser(data?.user || (await api.get(API.auth.me)));
//   },

//   async refresh() {
//     const data = await api.post(API.auth.refresh, null, { skipAuthRefresh: true });
//     tokenStore.set(data.accessToken, data.expiresIn);
//     return data;
//   },

//   async logout() {
//     try {
//       await api.post(API.auth.logout, null, { skipAuthRefresh: true });
//     } finally {
//       tokenStore.clear();
//     }
//   },

//   forgotPassword: (email) => api.post(API.auth.forgotPassword, { email: email.trim().toLowerCase() }, { skipAuthRefresh: true }),
// };

// // Demo accounts for local development and tests only. The require() sits behind a
// // build-time constant, so the demo code is removed from production bundles.
// let authService = realAuthService;
// if (process.env.NODE_ENV !== 'production' && appConfig.auth.useMockAuth) {
//   authService = require('./mockAuthService').default;
// }

// export default authService;





import api from '../services/api';
import tokenStore from '../services/tokenStore';
import { API } from '../config/apiEndpoints';
import appConfig from '../config/appConfig';
import { toSessionUser } from './sessionUser';

const realAuthService = {
  async login({ email, password, remember = false }) {
    const data = await api.post(
      API.auth.login,
      { email: email.trim().toLowerCase(), password, remember: Boolean(remember) },
      { skipAuthRefresh: true }
    );

    // Save token
    const token = data.token || data.accessToken;
    const expiresIn = data.expiresIn || 3600;
    if (token) {
      tokenStore.set(token, expiresIn);
      localStorage.setItem('rb_token', token);
    }

    // Build normalized user for sessionUser
    const rawUser = {
      id: data.userId || data.id,
      userId: data.userId || data.id,
      name: data.fullName || data.name,
      fullName: data.fullName || data.name,
      email: data.email,
      role: (data.role || '').toLowerCase(), // ensures 'traveller'
    };

    const sessionUser = toSessionUser(rawUser);
    localStorage.setItem('rb_user', JSON.stringify(sessionUser));
    return sessionUser;
  },

  async register({ role, name, fullName, email, phone, password }) {
  const personName = (fullName || name || '').trim();

  const formattedRole =
    role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();

  try {
    return await api.post(
      API.auth.register,
      {
        fullName: personName,
        email: email.trim().toLowerCase(),
        password,
        role: formattedRole,
      },
      { skipAuthRefresh: true }
    );
  } catch (err) {
    console.error('REGISTRATION ERROR:', {
      status: err.status,
      message: err.message,
      details: err.details,
      fieldErrors: err.fieldErrors,
    });

    throw err;
  }
},
 async restore() {
    try {
      const storedUser = localStorage.getItem('rb_user');
      const storedToken = localStorage.getItem('rb_token');
      if (storedUser && storedToken) {
        tokenStore.set(storedToken, 3600);
        return JSON.parse(storedUser);
      }
      throw new Error('No stored session');
    } catch {
      throw new Error('No stored session');
    }
  },

  async refresh() {
    const token = localStorage.getItem('rb_token');
    return { accessToken: token, expiresIn: 3600 };
  },

  async logout() {
    try {
      tokenStore.clear();
      localStorage.removeItem('rb_token');
      localStorage.removeItem('rb_user');
    } finally {
      tokenStore.clear();
    }
  },

  forgotPassword: (email) =>
    api.post(API.auth.forgotPassword, { email: email.trim().toLowerCase() }, { skipAuthRefresh: true }),
};

let authService = realAuthService;
if (process.env.NODE_ENV !== 'production' && appConfig.auth.useMockAuth) {
  authService = require('./mockAuthService').default;
}

export default authService;